import { Link } from "react-router-dom";

interface SectionTitleProps {
  label?: string;
  title: string;
  subtitle?: string;
  actionText?: string;
  actionTo?: string;
}

export default function SectionTitle({
  label,
  title,
  subtitle,
  actionText,
  actionTo,
}: SectionTitleProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {label && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-fire-line"></i>
            {label}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600 md:flex cursor-pointer"
        >
          {actionText}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}